const pythiaApiBaseUrl = "https://cimatroncopilotpluginapi.cimatron.com/api/v1";

const strings = {
    apiBaseUrl: pythiaApiBaseUrl,
    pythiaApiBaseUrl,
    // Used by browser-public mode (no WebView host) to bootstrap auth and speech.
    publicTokenUrl: `${pythiaApiBaseUrl}/Auth/public-token`,
    speechConfigUrl: `${pythiaApiBaseUrl}/OpenAI/getSpeechToTextConfig`,
};

export default strings;
